<template>
  <div class="container" :style="{
      backgroundImage: 'url( ' + bottomPic + ')',
      backgroundSize: 'cover',
      backgroundRepleat: 'no-repeat',
      backgroundPosition:'center center'
    }">
    <div class="wrapper" :style="{'height': windowHeight}">
      <div class="code-box">
        <div class="c-box">
          <div class="font001">扫描或长按识别下方二维码下载/打开代驾司机APP，完成司机认证噢！</div>
          <div class="img"><img :src="this.$commonUrl.cos() + '/image/designated/code.png'"></div>
          <div class="font002">完成代驾司机认证，即可获得活动奖励！<br>前往"<b>代驾司机APP-个人中心-我的钱包</b>" 查看奖励</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import util from '@/utils/util';

  export default {
    data() {
      return {
        paramsData: {},
        isLoading: false,
        allData: {},//活动基础信息
        bottomPic: '',
        iconPic: '',
        windowHeight: document.documentElement.clientHeight + 'px',   //实时屏幕高度
      };
    },

    created() {
    },
    mounted() {
    },
    methods: {
      //跳转活动规则
      goRule() {
        this.$router.push({
          name: 'toActivityRules',
          query: {
            activityId: this.paramsData.paramsOther.activityId,
            cityCode: this.paramsData.paramsOther.cityCode,
          },
        });
      },
      //我也要邀请
      wantToBtn() {
        this.$router.push({
          path: '/home/shareUniversal',
          query: this.$route.query,
        });
      },
    },
  };
</script>
<style lang="less" scoped>
  .container {
    background: #ffeaca;
    position: relative;

    .wrapper {
      display: table;
      text-align: center;
      margin: 0 auto;
    }

    .code-box {
      vertical-align: middle;
      display: table-cell;
      text-align: center;
      background: url("../../../assets/img/shareUniversal/bg001.png") no-repeat center center;
      background-size: 334px 504px;
      width: 334px;
      height: 504px;

      .c-box {
        height: 504px;
        padding: 32px 20px 0 20px;
        box-sizing: border-box;

        .font001 {
          font-size: 16px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 20px;
        }

        .img {
          padding: 70px 0 17px 0;
        }

        .font002 {
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 22px;

          b {

          }
        }
      }


    }
  }

</style>
